var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArcticonsLibremmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3249 7.57501L13.325 52.425C13.325 52.9422 13.5304 53.4382 13.8961 53.8039C14.2618 54.1696 14.7578 54.375 15.275 54.375L44.725 54.375C45.2421 54.375 45.7381 54.1696 46.1038 53.8039C46.2849 53.6228 46.4285 53.4078 46.5265 53.1712C46.6245 52.9346 46.675 52.6811 46.675 52.425L46.675 7.575C46.675 7.05783 46.4695 6.56184 46.1038 6.19614C45.7381 5.83045 45.2421 5.625 44.725 5.625L15.2749 5.625C14.7578 5.625 14.2618 5.83045 13.8961 6.19615C13.5304 6.56184 13.3249 7.05783 13.3249 7.57501V7.57501Z",
    stroke: "#111111",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.775 49.4L32.425 34.75C33.0433 34.1334 33.5339 33.4009 33.8687 32.5944C34.2034 31.7879 34.3757 30.9232 34.3757 30.05C34.3757 29.1768 34.2034 28.3122 33.8687 27.5056C33.5339 26.6991 33.0433 25.9666 32.425 25.35L17.7125 10.6375M42.2875 10.925L31.4 24.2125M42.2875 49.05L31.4 35.7625",
    stroke: "#111111",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArcticonsLibremmail);
export default __webpack_public_path__ + "static/media/arcticons_libremmail.7627de459d1f98836f7fd5ba777f06b8.svg";
export { ForwardRef as ReactComponent };